import React from 'react';

import HomeReviewes from './HomeReviewes/HomeReviewes';
import HomeReservation from './HomeReservation/HomeReservation';

import classes from './Home.module.scss';
import { condClass } from 'app/utils/general';



interface Props {
  backgroundImage: string;
  backgroundShadow: boolean;
  reviewes: boolean;
  topRightLogo: string | null;
  footerLogo: string | null;
}

const HomeView: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  return (
    <React.Fragment>
      <section
        className={condClass({ [classes['header']]: true, [classes['header--shadow']]: props.backgroundShadow })}
        style={{ backgroundImage: `url(${props.backgroundImage})` }}
      >
        {props.topRightLogo ? <img className={classes['mapLogo']} src={props.topRightLogo}></img> : null}
        <HomeReservation></HomeReservation>
        {props.footerLogo ? <img className={classes['footerLogoImg']} src={props.footerLogo} width="400"></img> : null}
      </section>
      {props.reviewes ? (
        <section className={classes['section']}>
          <HomeReviewes className={classes['section__content']}></HomeReviewes>
        </section>
      ) : null}
    </React.Fragment>
  );
};

HomeView.displayName = 'HomeView';
HomeView.defaultProps = {};

export default HomeView;
